import { useGoBack } from "@/common/hooks/useGoBack";
import { ChevronsRightIcon } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import QRCode from "react-qr-code";
import { usePosGetRegistration } from "../../hooks/usePosGetRegistration";
import Modal from "@/common/components/Modal";
import { useEffect, useState } from "react";
import GoBackButton from "@/common/components/GoBackButton";

const PosQrCode = () => {
  const goBack = useGoBack();
  const navigate = useNavigate();
  const { id } = useParams();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const { data: posRegistration, isError: posRegistrationIsError } = usePosGetRegistration(id);

  useEffect(() => {
    if (posRegistration?.is_associated && posRegistration.machine) {
      setIsSuccessModalOpen(true);
    }
  }, [posRegistration?.is_associated]);

  useEffect(() => {
    if (posRegistrationIsError && !isSuccessModalOpen) {
      setIsErrorModalOpen(true);
    }
  }, [posRegistrationIsError]);

  return (
    <>
      <div>
        <div className="flex justify-between items-center mb-6">
          <div className="flex gap-2 items-center">
            <GoBackButton fallback="/pos" />

            <p className="text-white-400 font-normal">
              POS
            </p>

            <ChevronsRightIcon color="#ffffffb3" />

            <h2 className="font-bold">
              Novo POS
            </h2>
          </div>
        </div>

        <div className="bg-[#FFFFFF0D] w-full h-[332px] rounded-lg p-6 flex flex-row gap-4">
          <div className="bg-white p-4 h-[288px] rounded-lg" style={{ backgroundColor: 'white' }}>
            <QRCode value={id!} />
          </div>

          <div className="bg-[#FFFFFF0D] w-full h-[93px] rounded-lg p-3 flex flex-col justify-center overflow-hidden">
            <h2 className="font-bold text-white text-[16px] m-0">
              POS
            </h2>

            <h2 className="text-white text-[14px] m-0 overflow-hidden text-ellipsis whitespace-nowrap">
              Realize a leitura do QR Code para associar o POS ao sistema Tcard.
            </h2>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isSuccessModalOpen}
        onCancel={() => navigate(`/pos/${posRegistration?.machine.id}`)}
        onConfirm={() => navigate(`/pos/${posRegistration?.machine.id}`)}
        title="POS associado com sucesso!"
        footer="Ir para tela do POS"
        titleClass="text-[20px]"
        showClose={false}
        body={(
          <div className='flex flex-col gap-3'>
            <div>
              <p className="text-sm text-white-300 italic font-light">
                Código
              </p>

              <p className="text-[16px] text-white-800">
                {posRegistration?.machine?.reference_number}
              </p>
            </div>

            <div>
              <p className="text-sm text-white-300 italic font-light">
                Modelo
              </p>

              <p className="text-[16px] text-white-800">
                {posRegistration?.machine?.model.display_name}
              </p>
            </div>
          </div>
        )}
      />

      <Modal
        isOpen={isErrorModalOpen}
        setIsOpen={setIsErrorModalOpen}
        onCancel={() => goBack({ fallback: '/pos' })}
        onConfirm={() => goBack({ fallback: '/pos' })}
        title="Ocorreu um erro ao cadastrar POS, tente novamente"
        footer="Voltar para tela inicial"
        titleClass="text-danger-soft text-[16px] font-normal"
        showClose={false}
      />
    </>
  );
};

export default PosQrCode;
